const confRelatedAcademicWeekFlagTypes = {
  UnSet: 0,
  AdmissionFlag: 1,
  InterventionPlanFlag: 2,
  RepositionFlag: 3,
  RegularVisitFlag: 4,
  IsBillingFlag: 5,
  IsRelatedServiceFlag: 6,
};

export default confRelatedAcademicWeekFlagTypes;
